/**
 * LEXe Logo Component — Admin Panel
 *
 * Uses bicolor PNG brand assets (LEX dark/white + e cyan).
 * Variants: light (white+cyan for dark bg), dark (navy+cyan for light bg)
 */

import logoDark from "@/assets/brand/logo-dark.png";
import logoLight from "@/assets/brand/logo-light.png";
import iconDark from "@/assets/brand/icon-dark.png";
import iconLight from "@/assets/brand/icon-light.png";

type Variant = "light" | "dark" | "auto";

function resolveVariant(variant: Variant): "light" | "dark" {
  if (variant !== "auto") return variant;
  return document.documentElement.classList.contains("dark") ? "light" : "dark";
}

export function LexeIcon({
  size = 40,
  variant = "auto",
  className,
}: {
  size?: number;
  variant?: Variant;
  className?: string;
}) {
  const v = resolveVariant(variant);
  const src = v === "dark" ? iconDark : iconLight;
  return (
    <img
      src={src}
      alt="LEXe"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}

export function LexeLogo({
  size = "md",
  variant = "auto",
  className,
}: {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: Variant;
  className?: string;
}) {
  const heights = { sm: 36, md: 48, lg: 72, xl: 96 };
  const h = heights[size];
  const v = resolveVariant(variant);
  const src = v === "dark" ? logoDark : logoLight;
  return (
    <img
      src={src}
      alt="LEXe"
      height={h}
      className={className}
      style={{ height: h, width: "auto", objectFit: "contain" }}
    />
  );
}
